import React from 'react';
// import LoaderImage from '@assets/images/fried@2x.png';
import cn from 'classnames';
import styles from './loader.module.css';

const Loader = (props) => {
  return (
    <div className={cn('mx-sm-0', props.noTransparent ? '' : styles.transparent, props.notFixed || styles.fixed)}>
      <div className={`row page mx-0 ${props.noTransparent ? '' : 'full-height'} justify-content-center align-items-center`}>
        <div className={cn(styles.imgSpin, 'od-spinner')} />
        {props.message && (
        <div className={cn('text-primary od-text-primary fw-600 fs-20 position-fixed', styles.message)}>{props.message}</div>
        )}
      </div>
    </div>
  );
};
export default Loader;
